module.exports = __webpack_public_path__ + "img/20190820134938391.4a67c3d2.jpg";